import { render } from "./RetributionsRankings.vue?vue&type=template&id=383cdecc"
import script from "./RetributionsRankings.vue?vue&type=script&lang=js"
export * from "./RetributionsRankings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__